import * as React from "react";

import Button from "@mui/material/Button";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import icon_calendar from "../../assets/icon_calendar.svg";
import icon_calendar_disabled from "../../assets/icon_calendar_disabled.svg";
import moment from "moment";

function ButtonField(props) {
  const {
    setOpen,
    label,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { "aria-label": ariaLabel } = {},
  } = props;

  return (
    <Button
      variant="outlined"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.((prev) => !prev)}
      sx={{
        minWidth: "150px",
        width: "100%",
        border: "1px solid #D2D2D2",
        color: "#343A40",
        justifyContent: "space-between",
        "&:hover": {
          border: "1px solid #D2D2D2",
          backgroundColor: "transparent",
        },
      }}
    >
      <span>{label ? `${label}` : ""}</span>
      <img
        src={disabled ? icon_calendar_disabled : icon_calendar}
        alt="icon_calendar"
        style={{ marginLeft: "6px" }}
      />
    </Button>
  );
}

export default function PickerWithButtonField(props) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(props.value || null);

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        slots={{
          ...props.slots,
          field: ButtonField,
        }}
        slotProps={{
          ...props.slotProps, field: { setOpen },
        }}
        {...props}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        label={value == null ? null : dayjs(value).format("DD/MM/YYYY")}
        value={dayjs(value)}
        minDate={dayjs().add(1, "day")}
        onChange={(newValue) => {
          setValue(newValue);
          props.dispatch({ type: "onChangeBeginDate", newValue });
        }}
      />
    </LocalizationProvider>
  );
}
